<!-- LOADER -->
@if (themeClass()) {
	<div [class]="'theme-wrapper ' + themeClass()">
		@if (showCrossFade()) {
			<div class="crossFadeCon">
				<div class="crossfade">
					<figure></figure>
					<figure></figure>
					<figure></figure>
					<figure></figure>
					<figure></figure>
					<figure></figure>
				</div>
			</div>
		}

		<!--SIDENAV-->
		<mat-sidenav-container>
			<mat-sidenav #sidenav [autoFocus]="false" [class.isTwoScreen]="isTwoScreen()" mode="over">
				<div class="sideNavHeader">
					<div class="sideNavHeaderTop">
						<div class="userCardCon">
							<div class="userButton">
								@if (hasLicenseModule(Modules.UserManagment)) {
									<mat-icon fontIcon="fa-user" fontSet="fad" />
								}

								@if (!hasLicenseModule(Modules.UserManagment) && clientProperties().isRecorder) {
									<mat-icon fontIcon="fa-record-vinyl" fontSet="fad" />
								}

								@if (
									!hasLicenseModule(Modules.UserManagment) &&
									!clientProperties().isRecorder &&
									clientProperties().isTablet
								) {
									<mat-icon fontIcon="fa-tablet" fontSet="fad" />
								}
							</div>

							<button (click)="openUserCard()" mat-button class="userCardMoreInfoBtn">
								{{ T.USER_CARD_CON_MORE_INFO_BTN_TXT | translate }}
							</button>
						</div>

						@if (userService.user) {
							<div class="userInformationCon">
								<div class="nameCon">
									@if (hasLicenseModule(Modules.UserManagment)) {
										<div class="firstName showDotsOnOverflow">
											{{ userService.user?.firstname }}
										</div>

										<div class="lastName showDotsOnOverflow">
											{{ userService.user?.lastname }}
										</div>
									}

									@if (!hasLicenseModule(Modules.UserManagment) && clientProperties().isRecorder) {
										<div class="firstName showDotsOnOverflow">{{ T.GLOBAL_TXT_SIMSTATION | translate }}</div>
									}

									@if (
										!hasLicenseModule(Modules.UserManagment) &&
										!clientProperties().isRecorder &&
										clientProperties().isTablet
									) {
										<div class="firstName showDotsOnOverflow">{{ T.GLOBAL_TXT_SIMSTATION | translate }}</div>
									}
								</div>

								<div class="roleCon">
									@if (hasLicenseModule(Modules.UserManagment)) {
										@for (userRole of userService.user?.roleIds; track userRole) {
											<span>
												{{ userRole }}
											</span>
										}
									}

									@if (!hasLicenseModule(Modules.UserManagment) && clientProperties().isRecorder) {
										<span>
											{{ T.APP_COMPONENT_CONTROL_UNIT | translate }}
										</span>
									}

									@if (
										!hasLicenseModule(Modules.UserManagment) &&
										!clientProperties().isRecorder &&
										clientProperties().isTablet
									) {
										<span>
											{{ T.APP_COMPONENT_REMOTE_TABLET | translate }}
										</span>
									}
								</div>

								<div class="emailCon">
									{{ userService.user?.email }}
								</div>
							</div>
						}
					</div>
				</div>

				<sim-side-navigation-menu [navigationMenuOpened]="sidenav.openedStart" (closeSidenavEmitter)="sidenav.close()" />
			</mat-sidenav>

			@if (showNav()) {
				<mat-toolbar [@slideInOut] color="primary" id="mainAppToolbar">
					<mat-toolbar-row>
						@if (showBurgerMenu()) {
							<div (click)="sidenav.toggle()" [matRippleCentered]="true" class="matRippleCon" mat-ripple>
								<div [class.xVisible]="sidenav.opened" class="hamburgerCloseBtn">
									<div [@hamburguerX]="!sidenav.opened ? 'hamburguer' : 'topX'" class="icon-bar"></div>
									<div [@hamburguerX]="!sidenav.opened ? 'hamburguer' : 'hide'" class="icon-bar"></div>
									<div [@hamburguerX]="!sidenav.opened ? 'hamburguer' : 'bottomX'" class="icon-bar"></div>
								</div>
							</div>
						}
						<div class="toolbar-center-wrapper">
							<sim-logo [inverted]="true" />
							@if (showSystemWarning()) {
								<div class="systemWarningContainer" id="systemShutdownWarning">
									<mat-icon fontIcon="fa-exclamation-triangle" fontSet="fas" inline />
									<span>
										{{ T.SYSTEM_SHUTDOWN_WARNING | translate }}
										<sim-countdown-timer
											(onTimeUp)="showSystemWarning.set(false)"
											[seconds]="nextSystemShutdownInSeconds"
											format="mm:ss"
										/>
									</span>

									<sim-button
										(onClick)="cancelSystemShutdown()"
										[icon]="{
											fontSet: 'fal',
											fontIcon: 'fa-times',
											themeColor: 'white',
										}"
										[label]="T.SYSTEM_SHUTDOWN_CANCEL"
										color="warn"
									/>
								</div>
							}
						</div>
						<sim-toolbar-menu />
					</mat-toolbar-row>
				</mat-toolbar>
			}

			<router-outlet />
		</mat-sidenav-container>
	</div>
}

<sim-system-actions />
